module.exports = __webpack_public_path__ + "static/media/CertificateSignatureEdited.4a2b638a.png";